module.exports = __webpack_public_path__ + "static/img/18.9b114cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/18.jpg
// module id = VqCj
// module chunks = 1